import {Injectable} from '@angular/core';
import {Headers, Http, RequestOptions, Response} from '@angular/http';
import {environment} from 'environment';
import 'rxjs/add/operator/map';
import {Observable} from 'rxjs/Observable';

@Injectable()
export class AuthRepository {

  constructor(private http: Http) { }

  public getLoggedIn(): Observable<boolean> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    return this.http.get(environment.auth.statusRoute, options)
      .map((response) => response.json())
      .map((response) => {
        return response.isAuthorized;
      });
  }

  public login(username: string, password: string): Observable<Response> {
    const headers: Headers = new Headers();
    headers.append('Content-Type', `application/json`);

    const options: RequestOptions = new RequestOptions({
      headers: headers,
      withCredentials: true,
    });

    const body: {username: string, password: string} = {
      username: username,
      password: password,
    };

    return this.http
      .post(environment.auth.loginRoute, body, options);
  }

  public logout(): Observable<Response> {
    const options: RequestOptions = new RequestOptions({
      withCredentials: true,
    });

    return this.http.post(environment.auth.logoutRoute, null, options);
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/shared/auth/repositories/auth.repository.ts